export const rfidTransactions = {
  name: 'RFID Transaction |||| RFID Transactions',
  fields: {
    id: 'Transaction ID',
    rfid_user_id: 'RFID User ID',
    card_uid: 'Card UID',
    card_alias: 'Card Alias',
    amount: 'Amount',
    type: 'Type',
    status: 'Status',
    payment_method: 'Payment Method',
    reference_id: 'Reference ID',
    description: 'Description',
    balance_before: 'Balance Before',
    balance_after: 'Balance After',
    metadata: 'Metadata',
    created_at: 'Created At',
    updated_at: 'Updated At',
    rfid_user: {
      name: 'User Name',
      email: 'User Email',
      phone: 'User Phone',
    },
  },
  types: {
    topup: 'Top Up',
    deduction: 'Deduction',
    refund: 'Refund',
    adjustment: 'Adjustment',
  },
  statuses: {
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
  },
  paymentStatuses: {
    pending: 'Pending',
    paid: 'Paid',
    failed: 'Failed',
    refunded: 'Refunded',
    all: 'All Status',
  },
  payment_methods: {
    credit_account: 'Credit Account',
    invoice: 'Invoice',
    vendor_billing: 'Vendor Billing',
    external: 'External',
  },
  filters: {
    q: 'Search',
    card_uid: 'Card UID',
    user_name: 'User Name',
    rfid_user_id: 'RFID User ID',
    payment_status: 'Payment Status',
    type: 'Transaction Type',
    status: 'Status',
    from_date: 'From Date',
    to_date: 'To Date',
    min_amount: 'Minimum Amount',
    max_amount: 'Maximum Amount',
  },
  summary: {
    total_transactions: 'Total Transactions',
    total_topups: 'Total Top-ups',
    total_deductions: 'Total Deductions',
  },
  sections: {
    transaction_info: 'Transaction Information',
    card_info: 'RFID Card Information',
    user_info: 'User Information',
    financial_details: 'Financial Details',
    additional_info: 'Additional Information',
  },
  actions: {
    export: 'Export CSV',
    refresh: 'Refresh',
  },
  messages: {
    exportSuccess: 'Transactions exported successfully',
    exportFailed: 'Failed to export transactions',
  },
  labels: {
    dateTime: 'Date/Time',
    user: 'User',
    amount: 'Amount',
    energy: 'Energy (kWh)',
    paymentMethod: 'Payment Method',
    paymentStatus: 'Payment Status',
  },
  calculationMethods: {
    single_window: 'Single Window',
    multi_window_meter_based: 'Multi-Window Meter Based',
    single_window_metadata: 'Single Window Metadata',
    accumulated_cost: 'Accumulated Cost',
    from_realtime_history: 'From Realtime History',
    simple_calculation: 'Simple Calculation',
  },
  show: {
    title: 'RFID Transaction Details',
    transactionInfo: 'Transaction Information',
    rfidUserInfo: 'RFID User Information',
    chargingSession: 'Charging Session',
    costBreakdown: 'Cost Breakdown',
    billingInfo: 'Billing Information',
    paymentDetails: 'Payment Details',
    notes: 'Notes',
    transactionId: 'Transaction ID',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    paidDate: 'Paid Date',
    createdAt: 'Created At',
    userId: 'User ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    sessionId: 'Session ID',
    charger: 'Charger',
    site: 'Site',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    energyDelivered: 'Energy Delivered',
    finalCost: 'Final Cost',
    energyCostsByWindow: 'Energy Costs by Time Window',
    totalEnergyCost: 'Total Energy Cost',
    totalIdleCost: 'Total Idle Cost',
    sessionFee: 'Session Fee',
    timeFee: 'Time Fee',
    finalTotal: 'Final Total',
    timezone: 'Timezone',
    calculation: 'Calculation',
    calculatedAt: 'Calculated at',
    billingPeriod: 'Billing Period',
    vendor: 'Vendor',
    vendorEmail: 'Vendor Email',
    siteId: 'Site ID',
    chargerId: 'Charger ID',
    vendorId: 'Vendor ID',
    sessionStart: 'Session Start',
    sessionEnd: 'Session End',
  },
};